/**
 * Next's prerender-abandonment digest. `HangingPromiseRejectionError`
 * (next/dist/server/dynamic-rendering-utils) carries it whenever a promise the
 * render was still holding rejects because the prerender already finished —
 * `fetch()`, `io()`, `connection()`, and a `'use cache'` call that outlived its
 * prerender all reject with this one class, differing only in the `expression`
 * named in the message.
 */
const NEXT_PRERENDER_ABANDONED_DIGEST = 'HANGING_PROMISE_REJECTION'

/**
 * True for Next's prerender-abandonment signal — framework control flow, never
 * an application failure.
 *
 * The render it belonged to was discarded; nothing was served to anyone. Next
 * expects it to keep flying (that is what `unstable_rethrow` is for), so a
 * boundary that catches it must not convert it into a response or an error log.
 *
 * Runtime neutral and free of `next` imports, so browser-shared code and
 * Workflow bundles can ask the question too.
 */
export function isNextPrerenderAbandonedError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'digest' in error &&
    (error as { digest?: unknown }).digest === NEXT_PRERENDER_ABANDONED_DIGEST
  )
}
